import { BaseChartElement } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/chart-elements/base';
import type { Chart as G2Chart } from '@tencent/chart/lib/antv/g2';
import {
    ChartElementType,
    IChartElement,
    IChartElementGroup,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-interaction.interface';

export type ILegendElement = IChartElement;
export class Legend extends BaseChartElement {
    public getElements(chart: G2Chart): Array<IChartElement | IChartElementGroup> {
        const g2LegendController = chart.controllers.find(controller => controller.name === 'legend');
        const g2LegendComponent = g2LegendController?.getComponents().find(comp => comp.type === 'legend');

        if (g2LegendComponent) {
            const bbox = g2LegendComponent.component.getBBox();
            const rect = {
                height: bbox.height,
                width: bbox.width,
                top: bbox.y,
                left: bbox.x,
            };
            const path = this.convertRectToPath(rect);
            const legendElement = {
                rect,
                path,
                extra: g2LegendComponent.extra,
                type: ChartElementType.LEGEND,
                id: ChartElementType.LEGEND,
            };

            return [legendElement];
        }

        return [];
    }
}
